import * as Scrivito from "scrivito";

import "./bentoGridWidget.scss";

Scrivito.provideComponent("BentoGridWidget", ({ widget }) => (
  <Scrivito.ContentTag
    content={widget}
    attribute="content"
    className="bento-grid"
  />
));
